class CustomSlider {
  constructor() {
    this.initialize()
  }

  initialize() {
    if(document.querySelector('.js-custom-slider') == null) return
    this.bindUI()
    this.appendDots()
    this.activeAutoplay()
    this.bindEvents()
  }

  bindUI() {
    this.ui = {}
    this.ui.$slider = document.querySelector('.js-custom-slider')
    if(this.ui.$slider == null) return 
    this.ui.$slides = this.ui.$slider.querySelectorAll('.js-custom-slide')
    this.ui.$prev = this.ui.$slider.querySelector('.js-custom-slider-prev')
    this.ui.$next = this.ui.$slider.querySelector('.js-custom-slider-next')
    this.previousIndex = 0;
    this.ui.$dotsWrapper = this.ui.$slider.querySelector('.js-custom-slider-dots')
    this.ui.$scrollTo = this.ui.$slider.querySelector('.js-scroll-to')
    this.totalSlides = this.ui.$slides.length
    if(this.ui.$slider.querySelector('.first') != null) {
      this.activeIndex = parseInt(this.ui.$slider.querySelector('.first').getAttribute('data-index'))
    } else {
      this.activeIndex = 0
    }
    const _that = this // ugly 
    this.autoplay = {
      state: true,
      id: null,
      timeInterval: 6000,
      start: function () {
        this.id = setInterval(() => {
          if(_that.activeIndex < (_that.totalSlides - 1)) {
            _that.activeIndex++
          } else {
            _that.activeIndex = 0
          }
          _that.changeSlide(_that.activeIndex)
          _that.updateActiveDot(_that.activeIndex)
        }, this.timeInterval)
      },
      reset: function () {
        clearInterval(this.id)
        this.start()
      },
      stop: function() {
        clearInterval(this.id)
      }
    }
  }

  bindEvents() {
    this.ui.$prev.addEventListener('click', this.onClick.bind(this))
    this.ui.$next.addEventListener('click', this.onClick.bind(this))

    const dots = this.ui.$slider.querySelectorAll('.js-custom-slider-dot')
    for (let i = 0; i < dots.length; i++) {
      dots[i].addEventListener('click', this.onDotClick.bind(this))
    }

    this.ui.$scrollTo.addEventListener('click', this.onScrollTo.bind(this))
  }

  onScrollTo() {
    const sliderHeight = this.ui.$slider.offsetHeight
    window.scroll({
      top: sliderHeight, 
      left: 0, 
      behavior: 'smooth'
    })
  }

  onDotClick(e) {
    let target = e.target
    let index = target.getAttribute('data-index')
 
    this.autoplay.stop();
    this.updatePreviousIndex(index);
    this.changeSlide(index)
    this.updateActiveDot(index)
  }

  onClick(e) {
    let target = e.currentTarget
    let direction
    this.autoplay.stop();

    if(target.classList.contains('js-custom-slider-prev')) {
      direction = 'prev'
      if(this.activeIndex == 0) {
        this.activeIndex = (this.totalSlides - 1)
      } else {
        this.activeIndex = this.activeIndex - 1
      } 
    } else if (target.classList.contains('js-custom-slider-next')) {
      direction = 'next'
      if(this.activeIndex == (this.totalSlides - 1)) {
        this.activeIndex = 0
      } else {
        this.activeIndex = this.activeIndex + 1
      }
    }

    // this.activeAutoplay()
    this.changeSlide(this.activeIndex, direction)
    this.updateActiveDot(this.activeIndex)
  }

  updatePreviousIndex(index) {
    if(index == 0) {
      this.previousIndex = (this.totalSlides - 1)
    } else {
      this.previousIndex = index - 1
    } 
  }

  changeSlide(index, direction = 'next') {
    let nextIndex = index + 1
    
    this.updatePreviousIndex(index);

    // UI UPDATE
    for (let i = 0; i < this.ui.$slides.length; i++) {
      this.ui.$slides[i].classList.remove('first')
    }

    if(direction == 'prev') {
      this.ui.$slides[nextIndex].classList.remove('next')
      this.ui.$slides[nextIndex].classList.add('hide')
      this.ui.$slides[nextIndex].style.zIndex = '20'
      this.ui.$slides[nextIndex].style.transform = 'translate3d(0, 0, 2px)'

      setTimeout(() => {
        this.ui.$slides[nextIndex].classList.remove('hide')
        this.ui.$slides[nextIndex].style.zIndex = '10'
        this.ui.$slides[nextIndex].style.transform = 'translate3d(0, 0, 1px)'
        this.ui.$slides[index].classList.add('next')
        this.ui.$slides[index].style.zIndex = '30'
        this.ui.$slides[index].style.transform = 'translate3d(0, 0, 3px)'
      }, 1000)
    } else {
      this.ui.$slides[this.previousIndex].classList.remove('next')
      this.ui.$slides[this.previousIndex].classList.add('hide')
      this.ui.$slides[index].style.zIndex = '20'
      this.ui.$slides[index].style.transform = 'translate3d(0, 0, 2px)'
      
      setTimeout(() => {
        this.ui.$slides[this.previousIndex].classList.remove('hide')
        this.ui.$slides[this.previousIndex].style.zIndex = '10'
        this.ui.$slides[this.previousIndex].style.transform = 'translate3d(0, 0, 1px)'
        this.ui.$slides[index].classList.add('next')
        this.ui.$slides[index].style.zIndex = '30'
        this.ui.$slides[index].style.transform = 'translate3d(0, 0, 3px)'
      }, 1000)
    }
  }

  updateActiveDot(index) {
    const dots = this.ui.$slider.querySelectorAll('.js-custom-slider-dot')

    for(let i = 0; i < dots.length; i++) {
      dots[i].classList.remove('is-active')
    }

    // Update active bullet
    setTimeout(() => {
      dots[index].classList.add('is-active')
    }, 100)
  }

  activeAutoplay() {
    if (this.autoplay.state) {
      this.autoplay.reset()
    }
  }

  appendDots() {
    for (let i = 0; i < this.ui.$slides.length; i++) {  
      const dot = document.createElement('div')
      if(i == 0) {
        dot.className = "dots__single js-custom-slider-dot"
      } else {
        dot.className = "dots__single js-custom-slider-dot"
      }
      dot.setAttribute('data-index', i)

      this.ui.$dotsWrapper.append(dot)
    }
  }
}

export default CustomSlider
